export const menuWidthByCss = 56;
export const menuFullWidthByCss = 240;
